import {trapFocus, removeTrapFocus} from '../vendor/theme-scripts/theme-a11y';

var selectors = {
  drawerWrappper: '[data-drawer]',
  drawerScrolls: '[data-drawer-scrolls]',
  underlay: '[data-drawer-underlay]',
  stagger: '[data-stagger-animation]',
  drawerToggle: 'data-drawer-toggle',
  focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
};

var classes = {
  isVisible: 'drawer--visible',
  displayNone: 'display-none',
};

var sections = {};

class Drawer {
  constructor(el) {
    this.drawer = el;
    this.drawerScrolls = this.drawer.querySelector(selectors.drawerScrolls);
    this.underlay = this.drawer.querySelector(selectors.underlay);
    this.key = this.drawer.dataset.drawer;
    const btnSelector = `[${selectors.drawerToggle}='${this.key}']`;
    this.buttons = document.querySelectorAll(btnSelector);
    this.staggers = this.drawer.querySelectorAll(selectors.stagger);

    this.connectToggle();
    this.connectDrawer();
    this.closers();
    this.staggerChildAnimations();
  }

  unload() {
    // wipe listeners
  }

  connectToggle() {
    this.buttons.forEach((btn) => {
      btn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          this.drawer.dispatchEvent(
            new CustomEvent('theme:drawer:toggle', {
              bubbles: false,
            })
          );
        }.bind(this)
      );
    });
  }

  connectDrawer() {
    this.drawer.addEventListener(
      'theme:drawer:toggle',
      function () {
        if (this.drawer.classList.contains(classes.isVisible)) {
          this.drawer.dispatchEvent(
            new CustomEvent('theme:drawer:close', {
              bubbles: false,
            })
          );
        } else {
          this.drawer.dispatchEvent(
            new CustomEvent('theme:drawer:open', {
              bubbles: false,
            })
          );
        }
      }.bind(this)
    );
    this.drawer.addEventListener('theme:drawer:close', this.hideDrawer.bind(this));
    this.drawer.addEventListener('theme:drawer:open', this.showDrawer.bind(this));
  }

  staggerChildAnimations() {
    this.staggers.forEach((el) => {
      const children = el.querySelectorAll(':scope > * > [data-animates]');
      children.forEach((child, index) => {
        child.style.transitionDelay = `${index * 50 + 10}ms`;
      });
    });
  }

  closers() {
    this.drawer.addEventListener(
      'keyup',
      function (evt) {
        if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
          return;
        }
        this.hideDrawer();
        this.buttons[0].focus();
      }.bind(this)
    );

    this.underlay.addEventListener(
      'click',
      function () {
        this.hideDrawer();
      }.bind(this)
    );
  }

  showDrawer() {
    this.drawer.classList.remove(classes.displayNone);
    // animates after display none is removed
    setTimeout(() => {
      this.buttons.forEach((el) => el.setAttribute('aria-expanded', true));
      this.drawer.classList.add(classes.isVisible);
      this.drawerScrolls.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
      const firstFocus = this.drawer.querySelector(selectors.focusable);
      trapFocus(this.drawer, {elementToFocus: firstFocus});
    }, 1);
  }

  hideDrawer() {
    this.buttons.forEach((el) => el.setAttribute('aria-expanded', true));
    this.drawer.classList.remove(classes.isVisible);
    this.drawerScrolls.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

    document.dispatchEvent(new CustomEvent('theme:sliderule:close', {bubbles: false}));
    removeTrapFocus();

    // adds display none after animations
    setTimeout(() => {
      if (!this.drawer.classList.contains(classes.isVisible)) {
        this.drawer.classList.add(classes.displayNone);
      }
    }, 800);
  }
}

const drawer = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(selectors.drawerWrappper);
    els.forEach((el) => {
      sections[this.id].push(new Drawer(el));
    });
  },
  onUnload: function () {
    sections[this.id].forEach((el) => {
      if (typeof el.unload === 'function') {
        el.unload();
      }
    });
  },
};

export default drawer;
